/**
 * @deprecated Esta função será descontinuada.
 * Existe outra implementação de `formatToSelect` no projeto
 * com tipagem mais robusta e documentação adequada.
 * As duas versões devem ser unificadas em breve; utilize a outra
 * implementação em novos desenvolvimentos.
 *
 * Formata a lista de itens da resposta para o padrão `{ key, text }`
 * utilizado em componentes de seleção.
 *
 * @param {Object} response - Objeto contendo a propriedade `items`.
 * @param {Array<any>} [response.items] - Lista de itens a serem formatados.
 * @returns {{ key: any, text: string }[] | undefined} Lista formatada ou `undefined`.
 */
export const formatToSelect = (response: { items?: Array<any> }) => {
  if (response?.items?.length) {
    return response.items.map(value => ({
      key: value.id,
      text: value.name
    }));
  }
};
